import React, { useState } from 'react'
import { find } from 'lodash'
import { Trans, t } from '@lingui/macro'

import { ButtonClean, ButtonPrimary, Modal } from 'front-end/src/components'

import Form, { FormRow } from '../../../components/common/form/Form'
import Label from '../../../components/common/form/label/Label'
import Input from '../../../components/common/form/input/Input'
import Textarea from '../../../components/common/form/textarea/Textarea'
import Select from '../../../components/common/select/Select'
import { SelectMonthsOfValidity } from '../components/SelectMonthsOfValidity'
import { useCertificateTemplatesQuery } from '../templates/CertificateTemplatesPage.codegen'
import { useCreateCertificationMutation } from './NewCertificationModal.codegen'

interface Props {
  onHide: () => void
}

export const NewCertificationModal = ({ onHide }: Props) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [templateId, setTemplateId] = useState<number>()
  const [monthsOfValidity, setMonthsOfValidity] = useState<number | null>(null)

  const { data } = useCertificateTemplatesQuery()
  const certificateTemplates = data?.admin?.organisation?.certificateTemplates

  const options =
    certificateTemplates
      ?.filter((t) => !t.deleted_at)
      .map((t) => ({
        label: t.name,
        value: t.id
      })) || []

  const [createCertificationFn] = useCreateCertificationMutation()

  return (
    <Modal
      show={true}
      onHide={onHide}
      header={t`Create a new certification`}
      controls={[
        <ButtonClean key={1} onClick={onHide}>
          <Trans>Cancel</Trans>
        </ButtonClean>,
        <ButtonPrimary
          key={2}
          className="Button__next"
          onClick={async () => {
            await createCertificationFn({
              variables: {
                title,
                description,
                templateId,
                monthsOfValidity
              }
            })
            onHide()
          }}
        >
          <Trans>Create</Trans>
        </ButtonPrimary>
      ]}
    >
      <Form>
        <FormRow>
          <Label htmlFor="certification_name">
            <Trans>Name</Trans>
          </Label>
          <Input
            className="Input__topicName"
            id="certification_name"
            fullWidth
            placeholder={t`Name of the certification`}
            onChange={(val) => {
              setTitle(val)
            }}
            value={title}
          />
        </FormRow>
        <FormRow>
          <Label htmlFor="certification_description">
            <Trans>Description</Trans>
          </Label>
          <Textarea
            id="certification_description"
            fullWidth
            onChange={(val) => {
              setDescription(val)
            }}
            value={description}
          />
        </FormRow>
        {options.length > 1 && (
          <FormRow>
            <Label htmlFor="certification_description">
              <Trans>Certificate template</Trans>
            </Label>
            <Select
              value={find(options, (option) => option.value === templateId)}
              options={options}
              onChange={(value) => value && setTemplateId(value.value)}
            />
          </FormRow>
        )}
        <FormRow>
          <Label htmlFor="certification_description">
            <Trans>Expires after</Trans> (<Trans>optional</Trans>)
          </Label>
          <SelectMonthsOfValidity
            value={monthsOfValidity}
            onChange={setMonthsOfValidity}
          />
        </FormRow>
      </Form>
    </Modal>
  )
}
